import { RootState } from 'types';
import { workerAdapter } from './slice';
export const workShiftSelector = workerAdapter.getSelectors(
  (state: RootState) => state.workShift.data
);
export const workerSelector = (state: RootState) => state.workShift;
